import { MOMENT_JS_US } from './us';
import { MOMENT_JS_ES } from './es';

const SELECT_LOCALE = {
  us: MOMENT_JS_US,
  es: MOMENT_JS_ES
};

export default function getTranslationsForMomentjs(locale: string) {
  return SELECT_LOCALE[locale || 'us'];
}
